<!--
 * @Author: Cathy
 * @Date: 2020-02-24 10:00:48
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:41:33
 * @Description: 联吧下载
 -->

<template>
  <div style="height: 100%">
    <div class="inner">
      <catalogue :list="list" />
      <!-- <div class="input_box">
        <div class="search_box"
             @click="tosearch">
          <input disabled
                 class="search"
                 type="text"
                 placeholder="搜索视频 / 图文教程" />
          <div class="icon">
            <van-icon name="search"
                      color="#000"
                      size="24" />
          </div>
        </div>
      </div> -->
      <!-- <div class="title_box">
        <div class="title"
             @click.stop="goBack(num)">{{title}}</div>
        <div class="title"
             @click.stop="goBack(-1)"
             v-if="first">>>{{first}}</div>
        <div class="title">>>{{name}}</div>
      </div> -->
      <div class="input_box">
        <van-icon name="arrow-left"
                  size="16"
                  color="#000"
                  @click="goBack"
                  style="margin: .1rem" />
        <div class="search_box"
             @click.stop="tosearch">
          <input disabled
                 class="search"
                 type="text"
                 placeholder="搜索视频 / 图文教程" />
          <div class="icon"
               @click.stop="tosearch">
            <van-icon name="search"
                      color="#919191"
                      size="18" />
          </div>
        </div>
      </div>
      <!-- <div class="list_box"
           @scroll.passive="scroll($event)"
           v-if="show">
        <van-cell :title="name"
                  @click="getlist" />
      </div> -->
      <div class="big_box"
           @scroll.passive="scroll($event)">
        <div class="detail">
          <div class="tItem"
               v-for="(item, index) in list"
               :key="index"
               @click.stop="directionsDetail(item.instructions_id,item.type)">
            <img :src="item.type == 1 || item.type == 4 ?item.video_page:item.pt_page" />
            <a :id="'title'+ index" />
            <p>{{index + 1}}.{{item.title}}</p>
            <!-- <div v-html="item.content" style="margin-top: 0.4rem"></div> -->
          </div>
        </div>

      </div>
      <down></down>
    </div>

  </div>
</template>

<script>
import { getWapList } from '../api/wap'
import catalogue from '../components/catalogue'
import down from '@/components/down'
export default {
  components: {
    catalogue,
    down
  },
  data () {
    return {
      page: 1,
      page_total: 1,
      list: [],
      id: '',
      cate_level: ''
    }
  },
  created () {
    if (this.$route.query.id) this.id = this.$route.query.id
    if (this.$route.query.cate_level) this.cate_level = this.$route.query.cate_level
    // this.onLoadData()
    this.getlist(this.id)
  },
  methods: {

    getlist (id) {
      getWapList({
        page_now: this.page,
        cate_id: this.id,
        cate_level: this.cate_level
      }).then(res => {
        if (this.page === 1) {
          this.list = res.result.list
        } else {
          this.list.push(...res.result)
        };
        this.page_total = res.page_total
      })
    },
    directionsDetail (id, type) {
      if (type === 2 || type === '2' || type === 5 || type === '5') {
        this.$router.push({
          path: '/videoDetail',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({
          path: '/directionsDetail',
          query: {
            id: id
          }
        })
      }
    },
    goBack () {
      this.$router.back()
    },
    scroll (e) {
      let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
      if (bottom === 0) {
        if (this.page < this.page_total) {
          this.page++
          this.getlist()
        }
      }
    },
    // onLoadData () {
    //   getList({ type: 3 })
    //     .then(res => {
    //       this.imgList = res.result.list
    //     })
    // },
    tosearch () {
      // console.log(222);
      this.$router.push({
        path: '/lbSearch'
      })
    }
  }
}
</script>

<style scoped>
.downloadImage {
  /* margin-top: 1rem; */
  text-align: center;
  /* position: fixed;
  bottom: 0; */
  /* left: 0; */
  width: 100%;
  padding: 0.2rem 0 1.2rem;
  background: #ffff;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
.download {
  /* height: 100vh; */
  /* background-color: #f3f3f3; */
  display: flex;
  flex-direction: column;
}
.search_box {
  width: 100%;
  background-color: #fff;
  padding: 0.2rem 0.2rem;
  position: relative;
  height: 1.1rem;
  display: flex;
}
.tips_box {
  margin-top: 0.24rem;
  font-size: 0.34rem;
  color: #121212;
  padding-left: 0.24rem;
}
.inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.list_box {
  padding: 0.28rem 0.48rem 0;
  /* flex: 1; */
  overflow-y: auto;
}
.box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  /* box-shadow: 0px 0px 0.46rem 0px rgba(0, 0, 0, 0.13); */
  margin-bottom: 0.26rem;
  min-height: 1.5rem;
  border-radius: 0.16rem;
  background-color: #faaa22;
}
.title {
  width: 5.45rem;
  font-size: 0.42rem;
  /* color: #121212; */
  font-weight: 500;
  line-height: 0.5rem;
  color: #fff;
}
.search {
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 0.3rem;
  font-size: 15px;
  background: #e7e7e7;
  border-radius: 0.35rem;
  border: none !important;
  line-height: 0.3rem;
}
.icon {
  position: absolute;
  top: 50%;
  right: 0.4rem;
  transform: translateY(-50%);
  align-items: center;
  height: 0.7rem;
  display: flex;
}
.big_box {
  flex: 1;
  /* background: red; */
  overflow: auto;
  margin-top: 0.46rem;
}
.detail {
  padding: 0 0.1rem 0;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
}
.tItem {
  margin-bottom: 0.3rem;
  width: 3.45rem;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
}
.tItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
.input_box {
  display: flex;
  align-items: center;
  padding-left: 0.2rem;
}
/* .downloadImage {
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.2rem 0;
  background: #f3f3f3;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
.list_box >>> .van-cell__title {
  font-size: 0.42rem !important;
  line-height: 0.5rem;
  width: 5.45rem;
}
.list_box >>> .van-cell {
  align-items: center;
  min-height: 1.5rem;
  box-shadow: 0px 0px 0.46rem 0px rgba(0, 0, 0, 0.13);
}
.input_box {
  padding: 0.2rem 0.4rem;
}
.search_box {
  width: 100%;
  position: relative;
  height: 0.9rem;
  display: flex;
  align-items: center;
}
.search_box .search {
  height: 100%;
  background: #fff;
  border-radius: 0.05rem;
  border: 1px solid rgba(216, 216, 216, 1);
  width: 100%;
  font-size: 0.28rem;
  padding: 0 0.2rem;
}
.search_box .icon {
  position: absolute;
  top: 50%;
  right: 0.2rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}
.inner {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
}
.top_tab {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #333;
}
.tab {
  flex: 1;
  text-align: center;
  font-size: 0.3rem;
  line-height: 0.8rem;
  color: #999;
}
.activ_tab {
  color: #fff;
}
.top_bar {
  padding: 0.2rem 0.5rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box {
  width: 1.3rem;
  height: 1.3rem;
  text-align: center;
  color: #4a4a4a;
  border: 1px solid #4a4a4a;
  font-size: 0.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.1rem;
  white-space: wrap;
}
.active_bar {
  color: #fff !important;
  border: none !important;
}
.title_box {
  line-height: 0.7rem;
  font-size: 0.28rem;
  padding-left: 0.2rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
}
.title {
  max-width: 33.3%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.big_box {
  flex: 1;
  overflow: auto;
  margin-top: 0.2rem;
}
.big_box >>> .van-cell {
  align-items: center;
  font-size: 0.28rem !important;
  line-height: 0.4rem;
}
.detail {
  padding: 0.3rem 0.1rem 0;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
}
.detailItem {
  padding: 0.4rem;
  border-radius: 0.16rem;
  box-shadow: 0 0 0.46rem 0 rgba(4, 0, 0, 0.13);
}
.detailItem p {
  color: #121212;
  font-size: 0.34rem;
  font-weight: bold;
}
.tItem {
  margin-bottom: 0.3rem;
  width: 3.45rem;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
}
.tItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0.2rem 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
} */
</style>
